class ColumnCarousel extends HTMLElement {
  constructor() {
    super();
    this.defaultOptions = {
      slidesPerView: "auto",
      spaceBetween: 0,
      navigation: {
        nextEl: ".column-carousel-button-next",
        prevEl: ".column-carousel-button-prev",
      },
    };
    this.selectors = {
      pagination: ".carousel-pagination",
      buttonOpenModal: "#js-handleModalItem",
      modalContainer: "#js-modalContainer",
    };

    this.init();
  }

  init() {
    const options = { ...this.defaultOptions };
    const buttonsOpenModal = this.querySelectorAll(
      `${this.selectors.buttonOpenModal}`
    );

    this.startCarousel(options);
    buttonsOpenModal.forEach((button) => {
      button.addEventListener("click", this.openModal);
    });
  }

  startCarousel(options) {
    const swiper = new Swiper(this, {
      init: false,
      ...options,
    });
    swiper.init();
  }

  openModal = (evt) => {
    evt.preventDefault();
    const target = evt.target;
    const targetIdReference = target.dataset.for;
    const itemCurrent = document.querySelector(
      `[data-id=${targetIdReference}]`
    );

    const itemCurrentTitle = itemCurrent.querySelector("h3").textContent || "";
    const itemCurrentDescription =
      itemCurrent.querySelector(".metafield-rich_text_field").innerHTML || "";
    const itemCurrentImg = itemCurrent.querySelector("img").src || "";
    const itemCurrentLink = itemCurrent.querySelector("[data-button]") || "";
    const itemCurrentLinkHref = itemCurrentLink.href || "";
    const itemCurrentLinkText = itemCurrentLink.textContent || "";

    this.setInfoModal(
      itemCurrentTitle,
      itemCurrentDescription,
      itemCurrentImg,
      itemCurrentLinkHref,
      itemCurrentLinkText
    );
  };

  setInfoModal = (title, description, img, linkHref, linkText) => {
    const modalContainer = document.querySelector("#js-modalContainer");
    let modalTitle = modalContainer.querySelector("h3");
    let modalDescription = modalContainer.querySelector(
      ".metafield-rich_text_field"
    );
    let modalImg = modalContainer.querySelector("img");
    let link = modalContainer.querySelector("a");

    modalTitle.textContent = title;
    modalDescription.innerHTML = description;
    modalImg.src = img;
    link.href = linkHref;
    link.textContent = linkText;

    modalContainer.classList.add("open");
  };
}

customElements.define("column-carousel", ColumnCarousel);
